import { useState } from 'react';
import { ContentListPage } from '../components/ContentListPage';
import { PricingPlanCard } from '../components/pricing/PricingPlanCard';
import { BillingIntervalToggle } from '../components/pricing/BillingIntervalToggle';
import { TALK_TO_ARVID_LABEL, TALK_TO_ARVID_URL } from '../constants/contact';
import {
  PLAN_DISPLAY,
  PLAN_MARKETING_FEATURES,
  type CheckoutInterval,
} from '../../../shared/schemas/subscription';

const APP_URL = import.meta.env.VITE_APP_URL || 'http://localhost:5173';

export function PricingPage() {
  const [plusInterval, setPlusInterval] = useState<CheckoutInterval>('year');

  const plusPrice =
    plusInterval === 'year'
      ? PLAN_DISPLAY.plus.annualPriceLabel ?? PLAN_DISPLAY.plus.priceLabel
      : PLAN_DISPLAY.plus.priceLabel;

  return (
    <ContentListPage title="Pricing">
      <div className="col-span-full grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
        <PricingPlanCard
          name={PLAN_DISPLAY.free.name}
          description={PLAN_DISPLAY.free.description}
          price={PLAN_DISPLAY.free.priceLabel}
          features={PLAN_MARKETING_FEATURES.free}
          ctaLabel="Start Free"
          ctaHref={`${APP_URL}/login`}
          ctaVariant="secondary"
        />
        <PricingPlanCard
          name={PLAN_DISPLAY.plus.name}
          description={PLAN_DISPLAY.plus.description}
          price={plusPrice}
          headerAction={
            <BillingIntervalToggle
              interval={plusInterval}
              onChange={setPlusInterval}
              ariaLabel="Plus billing interval"
            />
          }
          features={PLAN_MARKETING_FEATURES.plus}
          ctaLabel="Start Plus"
          ctaHref={`${APP_URL}/login`}
          ctaVariant="primary"
          secondaryCtaLabel={TALK_TO_ARVID_LABEL}
          secondaryCtaHref={TALK_TO_ARVID_URL}
          highlighted
        />
        <PricingPlanCard
          name={PLAN_DISPLAY.enterprise.name}
          description={PLAN_DISPLAY.enterprise.description}
          price={PLAN_DISPLAY.enterprise.priceLabel}
          headerAction={
            <BillingIntervalToggle
              interval="year"
              allowedIntervals={['year']}
              ariaLabel="Power billing interval"
            />
          }
          features={PLAN_MARKETING_FEATURES.enterprise}
          ctaLabel="Start Power"
          ctaHref={`${APP_URL}/login`}
          ctaVariant="secondary"
          secondaryCtaLabel={TALK_TO_ARVID_LABEL}
          secondaryCtaHref={TALK_TO_ARVID_URL}
        />
      </div>
    </ContentListPage>
  );
}
